import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { LayoutUtilsService } from "@app/core/_base/crud";
import { MatDialog } from "@angular/material";
import { ToastrService } from "ngx-toastr";
import { Subject } from "rxjs";
import { BrandService, BrandHomeService } from "@app/api/api";
import { environment } from "environments/environment";
import { debounceTime, map } from "rxjs/operators";
import { MatTableDataSource } from "@angular/material/table";
import { BrandHome } from "@app/model/brandHome";

const IN_DB = 1;
const NOT_IN_DB = 0;

@Component({
	selector: "meu-app-brand-logo-management",
	templateUrl: "./app-brand-logo-management.component.html",
	styleUrls: ["./app-brand-logo-management.component.scss"],
})
export class AppBrandLogoManagementComponent implements OnInit {
	displayedColumns: string[] = [
		"Index",
		"Logo",
		"Name",
		"Code",
		"Country",
		"Actions",
	];
	lstAllBrand: any = [];
	dataSource = new MatTableDataSource(this.lstAllBrand);
	total: any;
	pageSize = 10;
	pageIndex = 1;
	host: any;
	filter: any = "";
	isChanged = false;
	//Select brand logo
	public keyUpLogo = new Subject<KeyboardEvent>();
	filterBrandInput: string = "";
	filterBrand: string = "";
	totalLogo: number;
	selectBrandID: string;
	lstLogoBrand = [];
	pageLoad: number = 1;
	logoShow: number = 10;
	lstDelete = [];

	constructor(
		private layoutUtilsService: LayoutUtilsService,
		public dialog: MatDialog,
		private toastr: ToastrService,
		private ref: ChangeDetectorRef,
		private brandService: BrandService,
		private brandHomeService: BrandHomeService
	) {}
	ngOnInit() {
		this.keyUpLogo
			.pipe(
				map((event) => event),
				debounceTime(300)
			)
			.subscribe((value) => {
				this.filterBrand = "name@=*" + value;
				this.lstLogoBrand = [];
				this.getLogoBrand();
				//this.ref.detectChanges();
			});

		this.getAllBrandHome();
		this.getLogoBrand();
	}
	//Sort table logo brand home
	sortBrandHome() {
		this.lstAllBrand.sort((a, b) => {
			return a.sort_order - b.sort_order;
		});
		for (let i = 0; i < this.lstAllBrand.length; i++) {
			this.lstAllBrand[i].sort_order = i + 1;
		}
	}

	//Đổi vị trí 2 logo
	upLogo(id: string) {
		this.isChanged = true;
		//Sử dụng brand id vì có những logo chưa có id vì chưa xuống db
		var index = this.lstAllBrand.findIndex((p) => p.brandId == id);
		var ob = this.lstAllBrand.find((p) => p.brandId == id);
		if (index > 0) {
			this.swapLogo(index, index - 1); //index-1 phần tử nằm phía trước
			this.dataSource.data = this.lstAllBrand;
		}
	}
	downLogo(id: string) {
		var index = this.lstAllBrand.findIndex((p) => p.brandId == id);
		this.isChanged = true;
		if (index < this.lstAllBrand.length - 1) {
			this.swapLogo(index, index + 1); //index+1 phần tử nằm phía sau
			this.dataSource.data = this.lstAllBrand;
		}
	}
	swapLogo(index1: number, index2: number) {
		var temp = this.lstAllBrand[index1].sort_order;
		this.lstAllBrand[index1].sort_order = this.lstAllBrand[
			index2
		].sort_order;
		this.lstAllBrand[index2].sort_order = temp;
		this.sortBrandHome();
	}

	//Button click
	deleteLogo(id: string) {
		this.isChanged = true;
		var brand = this.lstAllBrand.find((p) => p.brandId == id);
		var brandIndex = this.lstAllBrand.findIndex((p) => p.brandId == id);

		const title = "Xóa logo";
		const description = "Bạn có chắc chắn muốn xóa logo này?";
		const waitDesciption = "Đang xử lý...";
		const dialogRef = this.layoutUtilsService.deleteElement(
			title,
			description,
			waitDesciption
		);

		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			} else {
				if (brand.status == IN_DB) {
					this.lstDelete.push(this.lstAllBrand[brandIndex]);
				}
				this.lstAllBrand.splice(brandIndex, 1);
				this.sortBrandHome();
				this.dataSource.data = this.lstAllBrand;
				this.ref.detectChanges();
			}
		});
	}
	saveChangeLogo() {
		this.isChanged = false;
		this.updateListHomeBrand();
		this.lstDelete = [];
		this.ref.detectChanges();
	}
	cancelChangeLogo() {
		const action = "Xác nhận";
		const title = "Hủy thao tác";
		const description = "Các thay đổi bạn đã thực hiện sẽ không được lưu.";
		const waitDesciption = "Đang xử lý...";
		const dialogRef = this.layoutUtilsService.updateElement(
			action,
			"warn",
			title,
			description,
			waitDesciption
		);
		dialogRef.afterClosed().subscribe((res) => {
			if (!res) {
				return;
			} else {
				this.isChanged = false;
				this.lstAllBrand = [];
				this.getAllBrandHome();
				this.ref.detectChanges();
				this.toastr.success("Hủy thao tác thành công");
			}
		});
	}
	addLogoBrandHome() {
		if (this.selectBrandID == "" || this.selectBrandID == null) {
			return;
		}
		this.isChanged = true;
		let indexLogoInTable = this.lstAllBrand.findIndex(
			(x) => x.brandId == this.selectBrandID
		);
		if (indexLogoInTable < 0) {
			var sort = 0;
			let logoBrand = this.lstLogoBrand.find(
				(x) => x.id == this.selectBrandID
			);
			if (this.lstAllBrand.length != 0) {
				sort = this.lstAllBrand[this.lstAllBrand.length - 1].sort_order;
			}
			let data = {
				brandId: logoBrand.id,
				name: logoBrand.name,
				code: logoBrand.code,
				logo: logoBrand.logo,
				nation: logoBrand.nation,
				sort_order: sort + 1,
				status: NOT_IN_DB, //Chưa nằm trong db (0)
			};

			this.lstAllBrand.push(data);
			this.dataSource.data = this.lstAllBrand;
			let indexLogo = this.lstLogoBrand.findIndex(
				(x) => x.id == this.selectBrandID
			);
			this.lstLogoBrand.splice(indexLogo, 1);
			this.selectBrandID == "";
		} else {
			const description = "Hãng bạn chọn đã được thêm";
			this.toastr.warning(description, "Thêm thất bại");
		}
	}

	//Lay data tu api
	getAllBrandHome() {
		this.lstAllBrand = [];
		this.brandHomeService.apiBrandHomesGet().subscribe((res) => {
			if (res.success) {
				this.lstAllBrand = [];
				for (let i = 0; i < res.data.collection.length; i++) {
					this.lstAllBrand.push({
						id: res.data.collection[i].id,
						brandId: res.data.collection[i].extend_brand.id,
						name: res.data.collection[i].extend_brand.name,
						code: res.data.collection[i].extend_brand.code,
						logo: res.data.collection[i].extend_brand.logo,
						nation: res.data.collection[i].extend_brand.nation,
						sort_order: res.data.collection[i].sort_order,
						status: IN_DB, //Đã nằm trong db (1)
					});
				}
				this.sortBrandHome();

				this.dataSource.data = this.lstAllBrand;
				this.pageSize = res.data.pagesize;
				this.pageIndex = res.data.pageIndex;
				this.total = res.data.total;
				this.host = environment.backendhost;
				this.ref.detectChanges();
			}
		});
	}
	//select
	getLogoBrand() {
		this.brandService
			.apiListBrandNotShowAtHomeGet(
				this.filterBrand,
				"",
				this.pageLoad,
				10
			)
			.subscribe((res) => {
				if (res.success) {
					for (let i = 0; i < res.data.collection.length; i++) {
						let index = this.lstLogoBrand.findIndex(
							(p) => p.id == res.data.collection[i].id
						);
						if (index == -1) {
							this.lstLogoBrand.push(res.data.collection[i]);
						}
					}

					this.pageLoad = res.data.pageIndex;
					this.logoShow = 10 * this.pageLoad;
					this.totalLogo = res.data.total;
				}
				this.ref.detectChanges();
			});
	}
	loadMore() {
		this.pageLoad += 1;
		this.selectBrandID = "";
		this.getLogoBrand();
	}

	//Cập nhật list brand home ở db
	updateListHomeBrand() {
		var countUnsuccess = 0;
		for (let i = 0; i < this.lstAllBrand.length; i++) {
			switch (this.lstAllBrand[i].status) {
				case IN_DB:
					let id = this.lstAllBrand[i].id;
					var data = {
						sort_order: this.lstAllBrand[i].sort_order,
					} as BrandHome;
					this.brandHomeService
						.apiBrandHomesIdPut(id, data)
						.subscribe((res) => {
							if (!res.success) {
								countUnsuccess++;
								this.toastr.error(res.message);
							}
						});
					break;
				case NOT_IN_DB:
					var dataNew = {
						brand_id: this.lstAllBrand[i].brandId,
						sort_order: this.lstAllBrand[i].sort_order,
					} as BrandHome;
					this.brandHomeService
						.apiBrandHomesPost(dataNew)
						.subscribe((res) => {
							if (!res.success) {
								countUnsuccess++;
								this.toastr.error(res.message);
							} else {
								this.lstAllBrand[i].status = IN_DB;
							}
						});
					break;
			}
		}
		this.deleteInDb();
		if (countUnsuccess == 0) {
			this.toastr.success("Lưu thành công!");
		}
	}

	deleteInDb() {
		for (let i = 0; i < this.lstDelete.length; i++) {
			var countUnsuccess = 0;
			this.brandHomeService
				.apiBrandHomesIdDelete(this.lstDelete[i].id)
				.subscribe((res) => {
					if (!res.success) {
						countUnsuccess++;
						this.toastr.error(res.message);
					}
				});
		}
		this.lstDelete = [];
	}
	search() {
		if (this.selectBrandID != "" && this.selectBrandID != null) {
			var selectedProduct;
			this.filterBrand = "name@=*";
			this.pageLoad = 1;

			selectedProduct = this.lstLogoBrand.find(
				(p) => p.id == this.selectBrandID
			);
			this.lstLogoBrand = [];
			this.lstLogoBrand.push(selectedProduct);
			this.getLogoBrand();
		}
	}
}
